import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = ({ textColorClass }) => {
    const { language, toggleLanguage } = useLanguage();

    return (
        <button
            onClick={toggleLanguage}
            className="language-switcher-flag hover:opacity-70 transition-opacity flex items-center"
            aria-label="Switch language"
            data-lang-target={language === 'en' ? 'it' : 'en'}
        >
            <img
                src={language === 'en' ? '/img/icons/flag-it.svg' : '/img/icons/flag-en.svg'}
                alt={language === 'en' ? 'Switch to Italian' : 'Switch to English'}
                className="w-4 h-4 object-contain"
            />
        </button>
    );
};

export default LanguageSwitcher;
